import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4dfc5bcb")
const _hoisted_1 = { class: "container-text-access" }
const _hoisted_2 = { class: "container-supporto-visuale" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode()
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, { onClick: $options.back }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      size: "large",
                      name: "arrow-back"
                    }),
                    _createTextVNode(_toDisplayString(_ctx.$t('schede.back')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      class: "ion-padding",
      id: "nav-child-content"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('menu.accessibility.subtitle')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('menu.accessibility.supportoVisuale')), 1),
          _hoisted_3,
          _createVNode(_component_ion_toggle, {
            modelValue: $data.attivaSupporto,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($data.attivaSupporto = $event)),
            onIonChange: _cache[1] || (_cache[1] = ($event: any) => ($options.notice())),
            "enable-on-off-labels": true
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    })
  ], 64))
}